//Javascript for the WECAN Employer Area Signup functionality
app.EmployerUsers = (
    function () {
        var users = {
            Index: function () {
                // global list of accordion ids for knowing which accordions to open back up when actions are complete
                var accordionIds = new Array();

                // global bool to display email change warning on an email change for an employer
                var shouldEmailChangeModalFire = true;

                // function to refresh the master list component, but to resubmit the form for filtering
                function refreshMasterListComponent() {
                    app.page.components["MasterEmployerUserList"][0].startViewMode(false,
                        $("#filterForm").serializeArray());
                };

                // Always refresh the filter after reactivate/remove/save in order to update the lists
                $(document).on("component-remove-complete component-reactivate-complete component-save-complete",
                    function () {
                        refreshMasterListComponent();
                    });

                // On cancel remove and save go ahead and flip the flag for the email warning back to tru to catch next potential user email change
                $(document).on("component-edit-cancel component-remove-complete component-save-complete",
                    function () {
                        shouldEmailChangeModalFire = true;
                    });

                $(document).on("component-bind-edit-mode-complete",
                    function (e, component) {
                        // make sure we're not adding a new user
                        // if we are, we don't want to show the email change modal
                        if (component.id !== 0) {
                            $("input[name='Email']").on("change",
                                function () {
                                    if (shouldEmailChangeModalFire) {
                                        //open the warning modal and set the flag to false to avoid showing again for the same user
                                        $("#confirmModal").modal("show");
                                        shouldEmailChangeModalFire = false;
                                    }
                                });
                        }

                        // event listener for vacancy select many filter
                        $('[data-role-name="VacancyAssignmentOptions"]').on("click", '[data-filter="vacancy-status"]', function () {
                            var value = parseInt($(this).val());
                            var selMany = $(this).siblings('[data-role="select-many"]').first();

                            selMany.find(".select-many-checkbox").each(function () {
                                app.page.log("data: " + $(this).find("input").data("vacancy-status-id"));
                                if (value === 0 || $(this).find("input").data("vacancy-status-id") === value) {
                                    $(this).show();
                                    //show group
                                    $(this).closest('[data-role="select-many-group"]').show();
                                }
                                else {
                                    $(this).hide();
                                    if ($(this).closest('[data-role="select-many-group"]').find(".select-many-checkbox:visible").length === 0) {
                                        //hide group
                                        $(this).closest('[data-role="select-many-group"]').hide();
                                    }
                                }
                            });

                            var selAll = selMany.find('[type="checkbox"][data-role~="selectall"]:visible');
                            var selAllChecked = true;

                            //loop through visible values, if any is false, then mark the box as not all selected
                            selMany.find('.select-many-checkbox input[type="checkbox"]:visible').each(function (ind, el) {
                                if ($(el).prop("checked") !== true) {
                                    selAllChecked = false;
                                    // returning false breaks from loop
                                    return false;
                                }
                            });

                            selAll.prop("checked", selAllChecked);
                        });

                        // create event listener for affiliation type dropdown
                        // if user is HR Admin or HR Assistant, do not show the vacancy assignment options
                        $("[data-role-name='VacancyAssignmentList']", component.el).on("change",
                            function () {
                                app.page.log($("[data-role-name='VacancyAssignmentList']", component.el));
                                if ($(this).val() === "1" || $(this).val() === "2") {
                                    // hide vacancy assignment options
                                    $("[data-role-name='VacancyAssignmentOptions']", component.el).hide();
                                    $("[data-role-name='VacancyAssignmentAll']", component.el).show();
                                } else {
                                    // show vacancy assignment options
                                    $("[data-role-name='VacancyAssignmentOptions']", component.el).show();
                                    $("[data-role-name='VacancyAssignmentAll']", component.el).hide();
                                }
                            });
                    });

                // When the accordions expand:
                // - load the data to the accordion based on the component id
                // - add the component id to the list to remember to expand if the component refreshes
                $(document).on("show.bs.collapse",
                    function (event) {

                        var element = event.target;
                        var userId = $(element).data("accordion-id");

                        // loading spinner
                        $("#assignedVacancies_" + userId).html('<div class="text-center"><img src="/Content/Images/Icons/loading.gif" /></div>');

                        app.page.log("Fired accordion show event: ");
                        app.page.log(event);
                        app.page.log("On element: ");
                        app.page.log(element);

                        // first, load the data into the accordion
                        //build the post object
                        var postData = { userId };
                        var theUrl = app.page.appPath + "/Employer/User/GetEmployerUserData";
                        //Make ajax request
                        $.ajax({
                            url: theUrl,
                            type: "POST",
                            data: postData,
                            success: function (data) {
                                app.page.log("successfully loaded assigned vacancies");
                                app.page.log(data);
                                $("#assignedVacancies_" + userId).html(data);
                            },
                            error: function (theError) {
                                //display toast on error
                                toastr.error("There was an error loading the assigned vacancies for this user.");
                            }
                        });

                        app.page.log("Accordion IDs: ");
                        app.page.log(accordionIds);

                        // finally, add the element to the list of IDs if needed
                        var index = accordionIds.indexOf(userId);
                        if (index === -1) {
                            accordionIds.push(userId);
                            //app.page.log(accordionIds);
                        }
                    });

                // when the accordions hide:
                // - clear the data from the accordion
                // - remove the ID from the list
                $(document).on("hide.bs.collapse",
                    function (event) {
                        var element = event.target;
                        var userId = $(element).data("accordion-id");

                        // clear assigned vacancies section from view
                        $("#assignedVacancies_" + userId).html("");

                        app.page.log("Fired accordion hide event: ");
                        app.page.log(event);
                        app.page.log("On element: ");
                        app.page.log(element);
                        app.page.log(accordionIds);

                        var index = accordionIds.indexOf(userId);
                        if (index > -1) {
                            accordionIds.splice(index, 1);
                        }
                        app.page.log(accordionIds);
                    });

                // On remove display a success message
                $(document).on("component-remove-complete",
                    function () {
                        toastr.success("User successfully deleted.");
                    });

                // When the component master list loads, assign functionality
                $(document).on("component-bind-view-mode-complete-MasterEmployerUserList",
                    function () {
                        $(".activeUserButton").off("click").on("click",
                            function () {
                                //Get the Id value from the button
                                var id = $(this).data("value");

                                //build the post object
                                var postData = { Id: id };
                                var theUrl = app.page.appPath + "/Employer/User/ReactivateDeletedUsers";
                                //Make ajax request
                                $.ajax({
                                    url: theUrl,
                                    type: "POST",
                                    data: postData,
                                    success: function () {
                                        //make sure to close the modal
                                        $("#reactivateUser_" + id).modal("hide");
                                        toastr.success("User successfully reactivated.");
                                        $(document).trigger("component-reactivate-complete");
                                    },
                                    error: function (theError) {
                                        //display toast on error
                                        toastr.error("There was an error reactivating this user, please try again and contact support if the problem persists.");
                                    }
                                });
                            });

                        $(".resendEmailButton").off("click").on("click",
                            function () {
                                //Get the Id value from the button
                                var id = $(this).data("value");

                                //build the post object
                                var postData = { Id: id };
                                var theUrl = app.page.appPath + "/Employer/User/ResendNewAccountEmailAsync";
                                //Make ajax request
                                $.ajax({
                                    url: theUrl,
                                    type: "POST",
                                    data: postData,
                                    success: function () {
                                        $("#resendEmail_" + id).modal("hide");
                                        toastr.success("Email successfully resent.");
                                    },
                                    error: function (theError) {
                                        //display toast on error
                                        toastr.error("There was an error resending the email, please try again and contact support if the problem persists.");
                                    }
                                });
                            });

                        var i;
                        app.page.log("Starting accordion ID check");
                        app.page.log(accordionIds);
                        for (i = 0; i < accordionIds.length; i++) {
                            var theId = accordionIds[i];
                            $("[data-accordion-id='" + theId + "']").collapse("show");
                        }
                    });
            }
        };

        return users;
    }()
);